export default {
    CBEMV: {
        application: 'CBEMV',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    CBCLESS: {
        application: 'CBCLESS',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    CONECS: {
        application: 'CONECS',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    CONECSCLESS: {
        application: 'CONECSCLESS',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    AMEX: {
        application: 'AMEX',
        startEncryption: '92500021600',
        endEncryption: '=99120000094900000'
    },
    AMEXCLESS: {
        application: 'AMEXCLESS',
        startEncryption: '92500021600',
        endEncryption: '=99120000094900000'
    },
    CBVAD: {
        application: 'CBVAD',
        startEncryption: '92500000400',
        endEncryption: '=95120100000000000'
    },
    'PLBS+': {
        application: 'PLBS+',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    PLBSGCB: {
        application: 'PLBSGCB',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    },
    DCCPLBS: {
        application: 'DCCPLBS',
        startEncryption: '92500000400',
        endEncryption: '=95120010000000000'
    }
};